/** The font stacks Sagskort Deluxe's names use, each a folder of data/map-glyphs. */
export const MAP_GLYPH_FONTS = [
  "NotoSans-Regular",
  "NotoSans-Medium",
  "NotoSans-Italic",
] as const;

/** The glyph ranges shipped: Latin-1, Latin Extended-A (Greenlandic ĸ, ĩ, ũ) and punctuation (– ’ “ ” … €). */
export const MAP_GLYPH_RANGES = ["0-255", "256-511", "8192-8447"] as const;

export const MAP_GLYPHS_PROTOCOL = "glyphs";

/** The style's glyphs: served by the website itself (src/app/map-glyphs), read through loadMapGlyphs. */
export const MAP_GLYPHS_URL = `${MAP_GLYPHS_PROTOCOL}:///map-glyphs/{fontstack}/{range}.pbf`;

const SHIPPED = new RegExp(
  `^${MAP_GLYPHS_PROTOCOL}:///map-glyphs/(${MAP_GLYPH_FONTS.join("|")})/(${MAP_GLYPH_RANGES.join("|")})\\.pbf$`,
);

const EMPTY = () => new ArrayBuffer(0);

/**
 * One glyph range for MapLibre, from the website's own /map-glyphs. MapLibre fails the whole tile, land and water
 * included, when a range it asks for cannot be loaded, so a range that is not shipped (a name in another script) or
 * does not arrive is an empty range: those letters are left out and the rest of the map is drawn.
 */
export async function loadMapGlyphs(
  url: string,
  signal?: AbortSignal,
  fetcher: typeof fetch = fetch,
): Promise<ArrayBuffer> {
  const shipped = SHIPPED.exec(url);
  if (!shipped) return EMPTY();
  try {
    const answer = await fetcher(
      `/map-glyphs/${shipped[1]}/${shipped[2]}.pbf`,
      {
        signal,
      },
    );
    return answer.ok ? await answer.arrayBuffer() : EMPTY();
  } catch (error) {
    if (signal?.aborted) throw error;
    return EMPTY();
  }
}
